export const tboData = [
    {
        id: 1,
        companyName: "ООО «Сергиево-Посадский региональный оператор»",
        measure: "Руб./м.3",
        price1: "1025,74",
        price2: "1056,50"
    }
    ]